

















































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { projectManage } from '@/api/finance.js';
import convertConfig from './components/convertConfig.vue';
import writeConfig from './components/writeConfig.vue';
import portfolioInfo from './components/portfolioInfo.vue';
import valueTable from './components/valueTable.vue';
import summaryTable from './components/summaryTable.vue';
import investTable from './components/investTable.vue';
import exitTable from './components/exitTable.vue';
// import eventTable from './components/eventTable.vue';
import unrealizedTable from './components/unrealizedTable.vue';
import realizedTable from './components/realizedTable.vue';
import moment from 'moment';

@Component({
  components: {
    convertConfig,
    writeConfig,
    portfolioInfo,
    valueTable,
    summaryTable,
    investTable,
    exitTable,
    unrealizedTable,
    realizedTable
    // eventTable
  }
})
class Detail extends Vue {
  projectId: number | null = null;
  dialogVisible = {
    write: false
  };
  showHistory: boolean = false;
  writeType: string = '';
  showMoreInfo: boolean = false;
  effectDate: any = null;
  dialog = {
    type: '',
    text: '',
    title: ''
  };
  visible: boolean = false;

  mounted() {
    let { projectId } = this.$route.query;
    this.projectId = +projectId;
    this.effectDate = moment(new Date(), 'YYYY-MM-DD');
    this.fetchDetail();

    window.addEventListener('storage', this.refreshData);
  }

  destroyed() {
    window.removeEventListener('storage', this.refreshData);
  }

  get canModify() {
    return (this.$store.state.middlePageDetail.detail || {}).canModify;
  }

  get canAuth() {
    return (this.$store.state.middlePageDetail.detail || {}).canAuth;
  }

  // 1-正常再管 2-write down 3-write off 4-drop
  get projectStatus() {
    return (this.$store.state.middlePageDetail.detail || {}).projectStatus;
  }

  get detail() {
    return this.$store.state.middlePageDetail.detail || {};
  }

  get tianchiProjectId() {
    return this.$store.state.middlePageDetail.tianchiProjectId || {};
  }

  async fetchDetail() {
    try {
      let { projectId } = this;
      this.$store.commit('middlePageDetail/setProjectId', projectId);
      this.$store.dispatch('middlePageDetail/fetchDetail');
    } catch (e) {
      console.log(e);
    }
  }

  hide(key) {
    this.dialogVisible[key] = false;
  }

  switchShowMore() {
    this.showMoreInfo = !this.showMoreInfo;
  }

  confirm(type) {
    let texts = {
      writedownRecover: '确定将该项目恢复在管吗？恢复后请手动调整【公司最新估值标准】，否则仍然为0。', // writeDown恢复有生效时间
      writeoffRecover: '确定将该项目恢复在管吗？该操作将取消项目中所有的Write Off的退出记录，请知晓。',
      drop: '确定Drop该项目吗？',
      dropRecover: '确定将该项目恢复在管吗？'
    };
    let titles = {
      writedownRecover: 'Write Down 项目恢复', // writeDown恢复有生效时间
      writeoffRecover: 'Write Off 项目恢复',
      drop: 'Drop 项目',
      dropRecover: '恢复项目'
    };
    this.dialog['type'] = type;
    this.dialog['text'] = texts[type];
    this.dialog['title'] = titles[type];
    this.effectDate = moment(new Date(), 'YYYY-MM-DD');
    this.visible = true;
  }

  writeDown() {
    this.dialogVisible.write = true;
    this.writeType = 'writeDown';
  }

  writeOff() {
    this.dialogVisible.write = true;
    this.writeType = 'writeOff';
  }

  statuChange(type) {
    let typeMap = {
      writedownRecover: 1,
      writeoffRecover: 1,
      drop: 4,
      dropRecover: 1
    };
    projectManage({
      projectId: this.projectId,
      type: typeMap[type],
      effectDate: type === 'writedownRecover' ? moment(this.effectDate).format('YYYYMMDD') : ''
    })
      .then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功');
          this.visible = false;
          this.fetchDetail();
        }
      })
      .catch(e => {
        this.$message.error(e.message);
      });
  }
  toDictionary() {
    this.$router.push(`/finance/middlePage/dataDictionary`);
  }
  refreshData(e) {
    if (e.key === 'handleSubmit') {
      this.fetchDetail();
    }
  }
  toSlice() {
    let routeData = this.$router.resolve({
      path: `/finance/middlePage/historySlice`,
      query: {
        projectId: this.$store.state.middlePageDetail.projectId
      }
    });
    window.open(routeData.href, '_blank');
  }
}

export default Detail;
